import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

class AmBrowserSyncService {
    constructor(zone) {
        this.zone = zone;
    }
    connect(name) {
        this.assertTarget(name);
        return new Channel(name, this.zone);
    }
    assertTarget(target) {
        if (!target.toLowerCase().startsWith('am')) {
            const targetToPascal = target.charAt(0).toUpperCase() + target.slice(1);
            const targetToKebab = target.toLowerCase();
            throw new Error(`Browser Sync target should start with the prefix "am". \nMaybe you should try "am${targetToPascal}" or "am-${targetToKebab}" instead.`);
        }
    }
}
/** @nocollapse */ AmBrowserSyncService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmBrowserSyncService, deps: [{ token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ AmBrowserSyncService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmBrowserSyncService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmBrowserSyncService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }]; } });
class Channel {
    constructor(name, zone) {
        this.name = name;
        this.zone = zone;
        this.out = new BehaviorSubject('');
        if (localStorage.getItem(this.name)) {
            this.out.next(localStorage.getItem(this.name));
        }
        this.connect();
    }
    getObservable() {
        return this.out.asObservable();
    }
    update(data) {
        this.out.next(data);
        localStorage.setItem(this.name, data);
        this.in.postMessage(data);
    }
    connect() {
        this.in = new BroadcastChannel(this.name);
        this.in.onmessage = message => this.zone.run(() => this.out.next(message.data));
    }
}

class AmBrowserSyncModule {
}
/** @nocollapse */ AmBrowserSyncModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmBrowserSyncModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ AmBrowserSyncModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: AmBrowserSyncModule });
/** @nocollapse */ AmBrowserSyncModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmBrowserSyncModule, providers: [AmBrowserSyncService] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmBrowserSyncModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [AmBrowserSyncService]
                }]
        }] });

/*
 * Public API Surface of am-browser-sync
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AmBrowserSyncModule, AmBrowserSyncService, Channel };
